module.exports = __webpack_public_path__ + "img/25.2f8a97cd.png";